import {
  CANCELACION_SUCCESS,
  CANCELACION_LOADING,
  CANCELACION_ERROR,
  CANCELACION_VALIDACANCELA,
  CANCELACION_RESET,
  RESET_PORTAL_CONTEXT
} from "../ActionTypes";

import cancelacionInitialState from "../initialStates/cancelacionInitialState";

const cancelacion = (state, { payload, type, adicional }) => {
  switch (type) {
    case CANCELACION_LOADING:
      return {
        ...state,
        cancelacion: {
          ...state.cancelacion,
          error: false,
          loading: true,
        },
      };
      case CANCELACION_SUCCESS:
      return {
        ...state,
        cancelacion: {
          ...state.cancelacion,
          loading: false,
          error: false,
          cancelaTurno: payload,
          lugarInicio: (adicional && adicional == "KIN") ? adicional: false,
        },
      };
    case CANCELACION_ERROR:
      return {
        ...state,
        cancelacion: {
          ...state.cancelacion,
          error: payload,
          loading: false,
        },
      };
    case CANCELACION_VALIDACANCELA:
      return {
        ...state,
        cancelacion: {
          ...state.cancelacion,
          validaCancelacion: payload,
        },
      };
    case CANCELACION_RESET:
      return cancelacionInitialState;
    case RESET_PORTAL_CONTEXT:
      return cancelacionInitialState;
      
    default:
      return state;
  }
};

export default cancelacion;
